import React from 'react';
import './TopBar.css';
import { Link } from 'react-router-dom';

const TopBar = ({setPagePosition}) => (
  <div className="TopBar">

    <div className="Wrapper2">
      <Link className="contactTop" to="Nachricht" onClick={() => {setPagePosition(11);}}>
        Kontakt aufnehmen
      </Link>


    </div>
  </div>
);








export default TopBar;